export default "__VITE_ASSET__YFlOcojt__"